import Axios from "../../configs/axios.config";

export const createAttendance = (data) => Axios.post(`/attendance/manual`, data).then(response => response.data.data);
export const updateAttendance = (data, id) => Axios.post(`/attendance/manual/${id}`, data).then(response => response.data.data);
export const getAttendanceList = (data) => Axios.get('/user', { params: data }).then(response => response.data);
export const getAttendanceDetail = (data) => Axios.get(`/attendance`,{ params: data }).then(response => response.data);
export const deleteAttendance = (id) => Axios.delete(`/attendance/${id}`);


export const getStudentByClassAndSection = (params) => Axios.get(`/attendance/import-initial-data`, { params }).then(response => response.data.data);

export const importStudentAttendance = (data) =>
    Axios.post(`/attendance/import`, data)

export const getStaffDailyAttendanceList = (data) => Axios.get('/daily-attendance', { params: data }).then(response => response.data);